import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertContract($input: ContractInput) {
    upsertContract(input: $input) {
      id
    }
  }
`

const cleanRequest = (field, value) => {
  switch (field) {
    case 'group':
      return { groupId: value?.id }
    case 'profile':
      return { profileId: value?.id }
    case 'groups':
      return { contractGroupIds: value?.map(group => group.id) }
    default:
      return { [field]: value }
  }
}

const EditableContract = ({ record, field, children, multiple = false, ...props }) => {
  const { t } = useTranslation('common')
  const canEdit = useSessionPermission('editUser')
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, {
    refetchQueries: ['Contract', 'Contracts', 'Users', 'User'],
    client: accountsClient
  })

  const handleRequest = value => {
    const params = { variables: { input: { id: record.id, ...cleanRequest(field, value) } } }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorMessage'), message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable
      value={record[field]}
      multiple={multiple}
      onSubmit={handleRequest}
      loading={loading}
      disabled={!canEdit}
      {...props}
    >
      {children}
    </Editable>
  )
}

export default EditableContract
